/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';
import { euCountries, countryToStatesMap, regionNotRequiredCountries, regionToCountriesMap } from 'js/constants.js';

const componentName = 'software-license-form';
class SoftwareLicenseForm extends Component {
    elements = {
        // Display
        container: this.element.querySelector(`.${componentName}__container`),
        modalContainer: this.element.closest('dialog'),
        signedOutContent: this.element.querySelector(`.${componentName}__content--unauthenticated`),
        formSuccessContent: this.element.querySelector(`.${componentName}__content--success`),
        formIneligibleContent: this.element.querySelector(`.${componentName}__content--ineligible`),
        formLimitReachedContent: this.element.querySelector(`.${componentName}__content--limit-reached`),
        formErrorContent: this.element.querySelector(`.${componentName}__content--error`),
        formContent: this.element.querySelector(`.${componentName}__content--form`),
        loaderContent: this.element.querySelector(`.${componentName}__content--loading`),
        // Form
        form: this.element.querySelector('form'),
        formSubmitButton: this.element.querySelector(`.${componentName}__form-submit`),
        signInLink: this.element.querySelector(`.${componentName}__content-action--sign-in`),
        closeDialogButtons: this.element.querySelectorAll(`.${componentName}__content-action--cancel`),
        defaultCountryOptions: this.element.querySelector(`.${componentName}-default-options--country`),
        countrySelect: this.element.querySelector('select[name="$Country"]'),
        stateSelect: this.element.querySelector('select[name="$StateorProvince"]'),
        canadiaOptIn: this.element.querySelector('input[name="canadianOptIn1"]',),
        gdprConsent: this.element.querySelector('input[name="gDPRConsent1"]'),
        // Hidden Inputs
        bpidInput: this.element.querySelector('input[name="$Question2Text"]'),
        hiddenEmailInput: this.element.querySelector('input[name="$PrepopEmailAddress"]'),
        urlInput: this.element.querySelector('input[name="$FormURL"]'),
        formNameInput: this.element.querySelector('input[name="elqFormName"]'),
        regionInput: this.element.querySelector('input[name="$Region"]'),
    };

    state = {
        isSignedIn: false,
        userInfo: {
            origin: 'Marketing',
            isTest: false,
            shipToBpid: '',
            softwarePortalLoginEmail: '',
            catalogNumber: '',
            intendedUse: '',
            contactFirstName: '',
            contactLastName: '',
            contactEmail: '',
            contactPhone: '',
            contactCompany: '',
            contactAddress1: '',
            contactAddress2: '',
            contactCity: '',
            contactProvince: 'N/A',
            contactPostCode: '',
            contactCountryCode: '',
            contactCountryName: '',
            contactFax: '',
        },
        userLicenseStatus: 'eligible',
        stateInputType: 'select',
    };

    constants = {
        eloquaEndpoint: '',
        licenseServletEndpoint: '/bin/rockwell-automation/software-license',
        theme: 'ra',
        requiredFields: [
            'origin',
            'softwarePortalLoginEmail',
            'catalogNumber',
            'intendedUse',
            'contactFirstName',
            'contactLastName',
            'contactEmail',
            'contactCompany',
            'contactAddress1',
            'contactCity',
            'contactProvince',
            'contactPostCode',
            'contactCountryCode',
            'contactCountryName',
        ],
        formFieldToUserInfoMap: {
            '$FirstName': 'contactFirstName',
            '$LastName': 'contactLastName',
            '$EmailAddress': 'contactEmail',
            '$Telephone': 'contactPhone',
            '$Company': 'contactCompany',
            '$AddressLine1': 'contactAddress1',
            '$AddressLine2': 'contactAddress2',
            '$City': 'contactCity',
            '$StateorProvince': 'contactProvince',
            '$Postcode': 'contactPostCode',
            '$Country': 'contactCountryName',
            '$Fax': 'contactFax',
            '$Comments': 'intendedUse',
        },
        inputMaxLengths: {
            '$FirstName': 40,
            '$LastName': 40,
            '$Company': 60,
            '$AddressLine1': 60,
            '$AddressLine2': 60,
            '$City': 32,
            '$Postcode': 10,
            '$Question3Text': 20,
            '$Comments': 250,
            '$Telephone': 20,
            '$EmailAddress': 128,
        },
    };

    setInputMaxLengths = () => {
        Object.keys(this.constants.inputMaxLengths).forEach((key) => {
            const input = this.elements.form.querySelector(`input[name="${key}"]`);
            if (input) {
                input.maxLength = this.constants.inputMaxLengths[key];
            }
        });
    };

    checkSignInStatus = () => {
        let loggedInData = {};
        if (typeof getPiraObj === 'function') {
            const piraObj = getPiraObj();
            loggedInData = {
                firstName: piraObj.fn,
                lastName: piraObj.ln,
                email: piraObj.em,
                phone: piraObj.myPhone,
                company: piraObj.companyName,
                countryCode: piraObj.country,
                bpid: piraObj.bpid,
            };
        } 
        if (window['userData']) {
            this.state.isSignedIn = true;
            loggedInData.firstName = loggedInData.firstName || window['userData'].firstName;
            loggedInData.lastName = loggedInData.lastName || window['userData'].lastName;
            loggedInData.email = loggedInData.email || window['userData'].email;
            loggedInData.phone = loggedInData.phone || window['userData'].phone;
            loggedInData.company = loggedInData.company || window['userData'].company;
            loggedInData.address = loggedInData.address || window['userData'].address;
            loggedInData.city = loggedInData.city || window['userData'].city;
            loggedInData.region = loggedInData.region || window['userData'].region;
            loggedInData.zip = loggedInData.zip || window['userData'].zip;
            loggedInData.countryCode = loggedInData.countryCode || window['userData'].countryCode;
            loggedInData.country = loggedInData.country || window['userData'].country;
            loggedInData.bpid = loggedInData.bpid || window['userData'].bpid;
        } else if (localStorage.getItem('loggedInData')) {
            try {
                const loginObject = JSON.parse(localStorage.getItem('loggedInData'));
                loggedInData.firstName = loggedInData.firstName || loginObject.firstName;
                loggedInData.lastName = loggedInData.lastName || loginObject.lastName;
                loggedInData.email = loggedInData.email || loginObject.email;
                loggedInData.phone = loggedInData.phone || loginObject.phone;
                loggedInData.company = loggedInData.company || loginObject.company;
                loggedInData.address = loggedInData.address || loginObject.address;
                loggedInData.city = loggedInData.city || loginObject.city;
                loggedInData.region = loggedInData.region || loginObject.region;
                loggedInData.zip = loggedInData.zip || loginObject.zip;
                loggedInData.countryCode = loggedInData.countryCode || loginObject.countryCode;
                loggedInData.country = loggedInData.country || loginObject.country;
                loggedInData.bpid = loggedInData.bpid || loginObject.bpid;
                this.state.isSignedIn = true;
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData) {
            this.state.userInfo.contactFirstName = loggedInData.firstName || '';
            this.state.userInfo.contactLastName = loggedInData.lastName || '';
            this.state.userInfo.contactEmail = loggedInData.email || '';
            this.state.userInfo.softwarePortalLoginEmail = loggedInData.email || '';
            this.state.userInfo.contactPhone = loggedInData.phone || '';
            this.state.userInfo.contactCompany = loggedInData.company || '';
            this.state.userInfo.contactAddress1 = loggedInData.address || '';
            this.state.userInfo.contactCity = loggedInData.city || '';
            this.state.userInfo.contactProvince = loggedInData.region || '';
            this.state.userInfo.contactPostCode = loggedInData.zip || '';
            this.state.userInfo.contactCountryCode = loggedInData.countryCode || '';
            this.state.userInfo.contactCountryName = loggedInData.country || '';
            this.state.userInfo.shipToFirstName = loggedInData.firstName || '';
            this.state.userInfo.shipToBpid = loggedInData.bpid || '';
        }
    };

    checkLicenseEligibility = async () => {
        let status = 'error';
        const licenseRequestUrl = new URL(this.constants.licenseServletEndpoint, window.location.origin);
        Object.keys(this.state.userInfo).forEach((key) => {
            licenseRequestUrl.searchParams.append(key, this.state.userInfo[key]);
        });
        try {
            const response = await fetch(licenseRequestUrl, {
                method: 'GET',
            });
            if (response.ok) {
                const data = await response.json();
                if (data.message === 'Success') {
                    status = 'success';
                } else if (data.id == 3001) {
                    status = 'limit-reached';
                } else if (data.id == 3004) {
                    status = 'ineligible';
                } else {
                    status = 'error';
                }
            } else {
                status = 'error';
            }
        } catch (error) {
            console.warn('Error fetching license eligibility:', error);
            status = 'error';
        }
        window.digitalData = window.digitalData || [];
        const formEvent = {
            event: 'formSubmit',
            formSubmitDetail: {
                status: status === 'success' ? status : 'error',
                formName: this.elements.modalContainer.id,
            }
        };
        if (status !== 'success') {
            formEvent.formSubmitDetail.errorMessage = status;
        }
        window.digitalData.push(formEvent);
        return status;
    };

    postToEloqua = async (formData) => {
        if (!this.constants.eloquaEndpoint) {
            console.warn('Eloqua endpoint is not set.');
            return;
        }
        try {
            const eloquaRequestUrl = new URL(this.constants.eloquaEndpoint);
            const eloquaPostBody = {};
            for (const [key, value] of formData.entries()) {
                if (key === '$Telephone--country-code') {
                    continue;
                } else if (key === '$Telephone') {
                    eloquaPostBody[key] = `${formData.get('$Telephone--country-code')}${value}`;
                } else if (key === '$PrepopEmailAddress') {
                    eloquaPostBody[key] = value;
                    eloquaPostBody['$EmailAddress'] = value;
                } else if (key === '$StateorProvince') {
                    if (this.state.stateInputType === 'select') {
                        eloquaPostBody['$StateorProvince'] = value;
                    }
                } else {
                    eloquaPostBody[key] = value;
                }
            }

            // Check for UTM parameters in query string
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('utm_campaign')) {
                eloquaPostBody['utm_campaign'] = urlParams.get('utm_campaign');
            }
            if (urlParams.get('utm_creative')) {
                eloquaPostBody['utm_creative'] = urlParams.get('utm_creative');
            }
            if (urlParams.get('utm_medium')) {
                eloquaPostBody['utm_medium'] = urlParams.get('utm_medium');
            }
            if (urlParams.get('utm_placement')) {
                eloquaPostBody['utm_placement'] = urlParams.get('utm_placement');
            }
            if (urlParams.get('utm_source')) {
                eloquaPostBody['utm_source'] = urlParams.get('utm_source');
            }
            if (urlParams.get('utm_content')) {
                eloquaPostBody['utm_content'] = urlParams.get('utm_content');
            }
            if (urlParams.get('utm_term')) {
                eloquaPostBody['utm_term'] = urlParams.get('utm_term');
            }

            const response = await fetch(eloquaRequestUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                mode: 'no-cors',
                body: new URLSearchParams(eloquaPostBody),
            });
            const data = await response.text();
            if (!response.ok) {
                console.warn('Eloqua error:', data);
            }
            return data;
        } catch (error) {
            console.warn('Error posting to Eloqua:', error);
            return;
        }
    };

    setUserInfo = (formData) => {
        for (const [key, value] of formData.entries()) {
            if (this.constants.formFieldToUserInfoMap[key]) {
                if (key === '$Telephone') {
                    this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = `${formData.get('$Telephone--country-code')}${value}`;
                } else if (key === '$StateorProvince') {
                    if (this.state.stateInputType === 'none') {
                        this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = 'N/A';
                    } else if (this.state.stateInputType === 'select') {
                        this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = value || this.state.userInfo[this.constants.formFieldToUserInfoMap[key]];
                    }
                } else {
                    this.state.userInfo[this.constants.formFieldToUserInfoMap[key]] = value || this.state.userInfo[this.constants.formFieldToUserInfoMap[key]];
                }
            }
        }
    };

    presetFormFields = () => {
        const formFields = this.elements.form.querySelectorAll('input, select');
        formFields.forEach((field) => {
            const fieldName = field.getAttribute('name');
            if (this.constants.formFieldToUserInfoMap[fieldName]) {
                const userInfoKey = this.constants.formFieldToUserInfoMap[fieldName];
                if (this.state.userInfo[userInfoKey]) {
                    if (this.constants.inputMaxLengths[fieldName]) {
                        field.value = this.state.userInfo[userInfoKey].slice(0, this.constants.inputMaxLengths[fieldName]);
                    } else {
                        field.value = this.state.userInfo[userInfoKey];
                    }
                }
            }
        });
    };

    handleCountryChange = () => {
        const selectedCountry = this.elements.countrySelect.value;
        const selectedCountryStates = countryToStatesMap[selectedCountry] || [];

        if (this.elements.stateSelect) {
            if (regionNotRequiredCountries.includes(selectedCountry) || selectedCountryStates.length === 0) {
                this.elements.stateSelect.closest(`.${this.constants.theme}-formfield`).classList.add('hidden');
                this.state.stateInputType = 'none';
            } else {
                this.elements.stateSelect.closest(`.${this.constants.theme}-formfield`).classList.remove('hidden');
                this.state.stateInputType = 'select';
                this.elements.stateSelect.innerHTML = '';
                const defaultOptionEle = document.createElement('option');
                defaultOptionEle.value = '';
                defaultOptionEle.text = '';
                defaultOptionEle.selected = true;
                this.elements.stateSelect.appendChild(defaultOptionEle);
                selectedCountryStates.forEach((state) => {
                    const optionEle = document.createElement('option');
                    optionEle.value = state.code;
                    optionEle.text = state.name;
                    this.elements.stateSelect.appendChild(optionEle);
                });
            }
        }

        if (selectedCountry === "Canada") {
            if (this.elements.canadiaOptIn) {
                this.elements.canadiaOptIn
                    .closest(`.${this.constants.theme}-formfield`)
                    .classList.remove("hidden");
                this.elements.canadiaOptIn.setAttribute(
                    "data-required",
                    "true",
                );
            }
        } else {
            if (this.elements.canadiaOptIn) {
                this.elements.canadiaOptIn
                    .closest(`.${this.constants.theme}-formfield`)
                    .classList.add("hidden");
                this.elements.canadiaOptIn.removeAttribute("data-required");
            }
        }
        if (euCountries.includes(selectedCountry)) {
            if (this.elements.gdprConsent) {
                this.elements.gdprConsent
                    .closest(`.${this.constants.theme}-formfield`)
                    .classList.remove("hidden");
                this.elements.gdprConsent.setAttribute("data-required", "true");
            }
        } else {
            if (this.elements.gdprConsent) {
                this.elements.gdprConsent
                    .closest(`.${this.constants.theme}-formfield`)
                    .classList.add("hidden");
                this.elements.gdprConsent.removeAttribute("data-required");
            }
        }
        let selectedRegion = 'NA';
        Object.keys(regionToCountriesMap).forEach((region) => {
            if (regionToCountriesMap[region].includes(selectedCountry)) {
                selectedRegion = region;
            }
        });
        this.elements.regionInput.value = selectedRegion;
        this.elements.formNameInput.value = `GatedContent-${selectedRegion}`;
    };

    /**
     * Handle Validation
     */
    handleValidation = () => {
        let hasError = false;
        const requiredFields = this.element.querySelectorAll('input[data-required], textarea[data-required], select[data-required]');

        [...requiredFields].forEach((fieldEle) => {
            if (fieldEle.disabled || fieldEle.closest(`.${this.constants.theme}-formfield`).classList.contains('hidden')) {
                return;
            }
            const isText = fieldEle.classList.contains(`${this.constants.theme}-input__input`);
            const isCheckbox = fieldEle.classList.contains(`${this.constants.theme}-checkbox__checkbox`);
            const isSelect = fieldEle.classList.contains(`${this.constants.theme}-select__select`);

            // Text Fields
            if (isText) {
                const inputValue = fieldEle.value;
                const isEmpty = inputValue === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.add(`${this.constants.theme}-input__input--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-input__input--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Checkboxes
            if (isCheckbox) {
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);
                const isEmpty = !fieldEle.checked;

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.add(`${this.constants.theme}-checkbox__checkbox--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-checkbox__checkbox--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Selects
            if (isSelect) {
                const isEmpty = fieldEle.value === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.add(`${this.constants.theme}-select__select--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'false');
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-select__select--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }
        });

        return hasError;
    };

    /**
     * Focus first invalid field for accessibility and user experience
     */
    focusFirstInvalidField = () => {
        const requiredFields = this.element.querySelectorAll("input[data-required], textarea[data-required], select[data-required]",);

        for (let i = 0; i < requiredFields.length; i++) {
            const field = requiredFields[i];
            const formfield = field.closest(`.${this.constants.theme}-formfield`);

            // Skip hidden fields
            if (field.disabled || formfield.classList.contains("hidden")) {
                continue;
            }

            // Check if field has invalid state
            if (formfield.classList.contains(`${this.constants.theme}-formfield--invalid`)) {
                field.focus();
                break;
            }
        }
    };

    addEventListeners = () => {
        this.elements.form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const hasError = this.handleValidation();
            if (hasError) {
                // Focus first invalid field - scroll to first error
                this.focusFirstInvalidField();
                return;
            }

            this.elements.formSubmitButton.classList.add('loading');
            const formData = new FormData(this.elements.form);
            this.setUserInfo(formData);

            const eloquaResponse = await this.postToEloqua(formData);
            const response = await this.checkLicenseEligibility();

            this.elements.formContent.classList.remove('active');
            switch (response) {
                case 'success':
                    this.elements.formSuccessContent.classList.add('active');
                    break;
                case 'ineligible':
                    this.elements.formIneligibleContent.classList.add('active');
                    break;
                case 'limit-reached':
                    this.elements.formLimitReachedContent.classList.add('active');
                    break;
                case 'error':
                    this.elements.formErrorContent.classList.add('active');
                    break;
                default:
                    break;
            }
            this.elements.formSubmitButton.classList.remove('loading');
        });

        this.elements.form.querySelectorAll('select').forEach((select) => {
            select.addEventListener('change', () => {
                if (select.value) {
                    select.classList.add('has-value');
                    select.classList.remove(`${this.constants.theme}-select__select--invalid`);
                    select.closest(`.${this.constants.theme}-formfield`).classList.remove(`${this.constants.theme}-formfield--invalid`);
                } else {
                    select.classList.remove('has-value');
                }
            });
        });

        this.elements.form.querySelectorAll('input, textarea').forEach((input) => {
            input.addEventListener('input', () => {
                if (input.value || input.checked) {
                    input.classList.remove(`${this.constants.theme}-input__input--invalid`);
                    input.classList.remove(`${this.constants.theme}-checkbox__checkbox--invalid`);
                    input.closest(`.${this.constants.theme}-formfield`).classList.remove(`${this.constants.theme}-formfield--invalid`);
                }
            });
        });

        this.elements.closeDialogButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.elements.modalContainer.close();
            });
        });

        this.elements.countrySelect.addEventListener('change', this.handleCountryChange);
    };

    initDom = () => {
        // Check sign-in status
        this.checkSignInStatus();
        if (!this.state.isSignedIn) {
            this.elements.loaderContent.classList.remove('active');
            this.elements.signedOutContent.classList.add('active');
            this.elements.signInLink.addEventListener('click', () => {
                if (document.querySelector('.account-menu__sign-in')) {
                    document.querySelector('.account-menu__sign-in').click();
                } else {
                    if (localStorage.getItem('adfsLogin')) {
                        window.location.href = localStorage.getItem('adfsLogin');
                    }
                }
            });
            return;
        }

        this.setInputMaxLengths();

        // Set data values
        this.state.userInfo.origin = this.elements.container.getAttribute('data-origin') || this.state.userInfo.origin;
        this.state.userInfo.catalogNumber = this.elements.container.getAttribute('data-catalog-number') || this.state.userInfo.catalogNumber;
        this.constants.theme = this.elements.container.getAttribute('data-theme') || this.constants.theme;
        this.constants.eloquaEndpoint = this.elements.container.getAttribute('data-eloqua-endpoint') || this.constants.eloquaEndpoint;
        this.elements.urlInput.value = window.location.origin + window.location.pathname;
        this.elements.bpidInput.value = this.state.userInfo.shipToBpid || this.elements.bpidInput.value;
        this.elements.hiddenEmailInput.value = this.state.userInfo.softwarePortalLoginEmail || this.elements.hiddenEmailInput.value;


        // Init form fields
        if (this.elements.countrySelect && this.elements.countrySelect.querySelectorAll('option').length <= 1) {
            this.elements.defaultCountryOptions.querySelectorAll('option').forEach(option => {
                this.elements.countrySelect.appendChild(option);
            });
        }
        this.elements.defaultCountryOptions.remove();

        this.presetFormFields();
        if (this.elements.stateSelect) {
            this.handleCountryChange();
            this.elements.stateSelect.value = this.state.userInfo.contactProvince || this.elements.stateSelect.value;
        }

        this.elements.form.querySelectorAll('select').forEach((select) => {
            if (select.value) {
                select.classList.add('has-value');
            } else {
                select.classList.remove('has-value');
            }
        });

        this.elements.form.querySelector('input[name="$EmailAddress"]').disabled = true;
        this.elements.form.querySelector('input[name="$EmailAddress"]').classList.add('ra-input__input--disabled');
        this.elements.loaderContent.classList.remove('active');
        this.elements.formContent.classList.add('active');
    };

    /**
     * Initialize Component
     */
    init = () => {
        if (typeof getPiraObj === 'function' || window.location.hostname.includes('localhost')) {
            this.initDom();
            this.addEventListeners();
        } else {
            document.addEventListener('piraLoadedSynced', () => {
                this.initDom();
                this.addEventListeners();
            });
        }
    };
}

registerComponent(`.${componentName}`, SoftwareLicenseForm);
